/**
 * CollectorSessions - lista sesji inwentaryzacyjnych i formularz tworzenia nowej.
 * Wyodrebniony z KolektorPage.jsx.
 */

import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const CollectorSessions = ({
  sessions,
  loading,
  showNewSessionForm, setShowNewSessionForm,
  newSessionName, setNewSessionName,
  newSessionType, setNewSessionType,
  handleCreateSession,
  handleSelectSession,
  handleDeleteSession,
  locationId,
  selectedInvoiceId, setSelectedInvoiceId,
  sessionDate, setSessionDate,
}) => {
  const [invoices, setInvoices] = useState([]);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const sessionsTabState = useState('active');
  const sessionsPageState = useState(1);

  useEffect(() => {
    if (newSessionType === 'delivery_check' && locationId) {
      setLoadingInvoices(true);
      api.get(`/collector/delivery-invoices?location_id=${locationId}`)
        .then(res => setInvoices(res.data?.data || []))
        .catch(() => setInvoices([]))
        .finally(() => setLoadingInvoices(false));
    }
  }, [newSessionType, locationId]);

  // Uzgodnij biezaca strone paginacji z liczba pozycji.
  // Gdy lista sie kurczy (sesja skonwertowana/usunieta lub zmiana zakladki),
  // a aktualna strona wykracza poza zakres, cofnij na ostatnia dostepna strone,
  // zeby nie pokazywac pustej listy przy niepustym zbiorze.
  const [sessionsTabValue] = sessionsTabState;
  const [sessionsPageValue, setSessionsPageValue] = sessionsPageState;
  useEffect(() => {
    const PAGE_SIZE = 6;
    const list = sessions.filter(s => sessionsTabValue === 'active'
      ? (s.status === 'in_progress' || s.status === 'paused')
      : (s.status === 'converted' || s.status === 'completed'));
    const totalPages = Math.max(1, Math.ceil(list.length / PAGE_SIZE));
    if (sessionsPageValue > totalPages) {
      setSessionsPageValue(totalPages);
    }
  }, [sessions, sessionsTabValue, sessionsPageValue, setSessionsPageValue]);

  return (
  <div>
    {/* Formularz nowej sesji */}
    {showNewSessionForm ? (
      <div style={{
        backgroundColor: 'var(--card-bg)',
        padding: '1rem',
        borderRadius: '8px',
        marginBottom: '1rem',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        {/* Nazwa sesji */}
        <input
          type="text"
          value={newSessionName}
          onChange={(e) => setNewSessionName(e.target.value)}
          placeholder="Nazwa sesji (np. Inwentura luty 2026)"
          style={{
            width: '100%',
            padding: '0.75rem',
            fontSize: '14px',
            border: '1px solid var(--border)',
            borderRadius: '4px',
            marginBottom: '0.75rem'
          }}
          autoFocus
        />

        {/* Data sesji */}
        <div style={{ marginBottom: '0.75rem' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', marginBottom: '0.25rem', color: 'var(--text-secondary)' }}>
            Data dokumentu:
          </label>
          <input
            type="date"
            value={sessionDate || new Date().toISOString().split('T')[0]}
            onChange={(e) => setSessionDate(e.target.value)}
            style={{
              padding: '6px 10px', fontSize: '12px', border: '1px solid var(--border)',
              borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)'
            }}
          />
        </div>

        {/* Wybor typu inwentury */}
        <div style={{ marginBottom: '0.75rem' }}>
          <div style={{
            fontSize: '12px',
            fontWeight: '600',
            marginBottom: '0.5rem',
            color: 'var(--text-secondary)'
          }}>
            Typ inwentury:
          </div>

          {/* Czastkowa */}
          <div
            onClick={() => setNewSessionType('partial')}
            style={{
              padding: '0.75rem',
              marginBottom: '0.5rem',
              border: `2px solid ${newSessionType === 'partial' ? 'var(--success)' : 'var(--border)'}`,
              borderRadius: '8px',
              cursor: 'pointer',
              backgroundColor: newSessionType === 'partial' ? 'var(--success-light)' : 'var(--card-bg)'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.25rem'
            }}>
              <span style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                border: `2px solid ${newSessionType === 'partial' ? 'var(--success)' : 'var(--border)'}`,
                backgroundColor: newSessionType === 'partial' ? 'var(--success)' : 'var(--card-bg)' ,
                display: 'inline-block'
              }} />
              <span style={{ fontWeight: '600', fontSize: '13px' }}>
                Czastkowa
              </span>
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', paddingLeft: '24px' }}>
              Tylko zeskanowane produkty sa aktualizowane.
              Pozostale produkty zachowuja swoj stan.
            </div>
          </div>

          {/* Calosciowa */}
          <div
            onClick={() => setNewSessionType('full')}
            style={{
              padding: '0.75rem',
              border: `2px solid ${newSessionType === 'full' ? 'var(--danger)' : 'var(--border)'}`,
              borderRadius: '8px',
              cursor: 'pointer',
              backgroundColor: newSessionType === 'full' ? 'var(--danger-light)' : 'var(--card-bg)'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.25rem'
            }}>
              <span style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                border: `2px solid ${newSessionType === 'full' ? 'var(--danger)' : 'var(--border)'}`,
                backgroundColor: newSessionType === 'full' ? 'var(--danger)' : 'var(--card-bg)' ,
                display: 'inline-block'
              }} />
              <span style={{ fontWeight: '600', fontSize: '13px' }}>
                Calosciowa
              </span>
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', paddingLeft: '24px' }}>
              <strong style={{ color: 'var(--danger)' }}>UWAGA:</strong> Wszystkie produkty,
              ktore NIE zostaly zeskanowane, beda mialy stan wyzerowany!
            </div>
          </div>

          {/* Przyjęcie wewnętrzne (PW) */}
          <div
            onClick={() => setNewSessionType('pw')}
            style={{
              padding: '0.75rem',
              marginTop: '0.5rem',
              border: `2px solid ${newSessionType === 'pw' ? 'var(--info)' : 'var(--border)'}`,
              borderRadius: '8px',
              cursor: 'pointer',
              backgroundColor: newSessionType === 'pw' ? 'var(--info-light)' : 'var(--card-bg)'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.25rem'
            }}>
              <span style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                border: `2px solid ${newSessionType === 'pw' ? 'var(--info)' : 'var(--border)'}`,
                backgroundColor: newSessionType === 'pw' ? 'var(--info)' : 'var(--card-bg)',
                display: 'inline-block'
              }} />
              <span style={{ fontWeight: '600', fontSize: '13px' }}>
                Przyjecie wewnetrzne (PW)
              </span>
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', paddingLeft: '24px' }}>
              Skanuj produkty do przyjecia. Po zakonczeniu sesji
              mozesz utworzyc dokument PW z poziomu magazynu.
            </div>
          </div>

          {/* Kontrola dostawy */}
          <div
            onClick={() => setNewSessionType('delivery_check')}
            style={{
              padding: '0.75rem',
              marginTop: '0.5rem',
              border: `2px solid ${newSessionType === 'delivery_check' ? 'var(--warning)' : 'var(--border)'}`,
              borderRadius: '8px',
              cursor: 'pointer',
              backgroundColor: newSessionType === 'delivery_check' ? 'var(--warning-light)' : 'var(--card-bg)'
            }}
          >
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              marginBottom: '0.25rem'
            }}>
              <span style={{
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                border: `2px solid ${newSessionType === 'delivery_check' ? 'var(--warning)' : 'var(--border)'}`,
                backgroundColor: newSessionType === 'delivery_check' ? 'var(--warning)' : 'var(--card-bg)',
                display: 'inline-block'
              }} />
              <span style={{ fontWeight: '600', fontSize: '13px' }}>
                Kontrola dostawy
              </span>
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', paddingLeft: '24px' }}>
              Skanuj produkty z dostawy i porownaj z faktura zakupowa.
              Raport roznic pomaga wykryc braki i nadwyzki.
            </div>
          </div>

          {/* Wybór faktury dla kontroli dostawy */}
          {newSessionType === 'delivery_check' && (
            <div style={{ marginTop: '0.75rem', padding: '0.75rem', backgroundColor: 'var(--bg)', borderRadius: '8px', border: '1px solid var(--border)' }}>
              <div style={{ fontSize: '12px', fontWeight: '600', marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>
                Wybierz fakture do kontroli:
              </div>
              {loadingInvoices ? (
                <div style={{ textAlign: 'center', padding: '0.5rem', color: 'var(--text-muted)', fontSize: '12px' }}>Ładowanie faktur...</div>
              ) : invoices.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '0.5rem', color: 'var(--text-muted)', fontSize: '12px' }}>Brak faktur</div>
              ) : (
                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {invoices.map(inv => (
                    <div
                      key={inv.id}
                      onClick={() => setSelectedInvoiceId(inv.id)}
                      style={{
                        padding: '0.5rem',
                        marginBottom: '0.25rem',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        border: selectedInvoiceId === inv.id ? '2px solid var(--warning)' : '1px solid var(--border)',
                        backgroundColor: selectedInvoiceId === inv.id ? 'var(--warning-light)' : 'var(--card-bg)',
                        fontSize: '12px'
                      }}
                    >
                      <div style={{ fontWeight: '600' }}>{inv.numer_faktury}</div>
                      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                        {inv.dostawca_nazwa} | {inv.data_faktury} | {inv.pozycje_count} poz. | {parseFloat(inv.suma_brutto || 0).toFixed(2)} zł
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Przyciski */}
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            onClick={handleCreateSession}
            disabled={loading}
            style={{
              flex: 1,
              padding: '6px 12px',
              border: `1px solid ${newSessionType === 'full' ? 'var(--danger)' : newSessionType === 'pw' ? 'var(--info)' : newSessionType === 'delivery_check' ? 'var(--warning)' : 'var(--success)'}`,
              color: newSessionType === 'full' ? 'var(--danger)' : newSessionType === 'pw' ? 'var(--info)' : newSessionType === 'delivery_check' ? 'var(--warning)' : 'var(--success)',
              fontSize: '12px'
            }}
          >
            {newSessionType === 'full' ? 'Utworz calosciowa' : newSessionType === 'pw' ? 'Utworz sesje PW' : newSessionType === 'delivery_check' ? 'Rozpocznij kontrole' : 'Utworz'}
          </button>
          <button
            onClick={() => {
              setShowNewSessionForm(false);
              setNewSessionType('partial');
            }}
            style={{
              padding: '6px 12px',
              border: '1px solid var(--text-muted)',
              color: 'var(--text-muted)',
              fontSize: '12px'
            }}
          >
            Anuluj
          </button>
        </div>
      </div>
    ) : (
      <button
        onClick={() => setShowNewSessionForm(true)}
        style={{
          width: '100%',
          padding: '6px 12px',
          border: '1px solid var(--success)',
          color: 'var(--success)',
          fontSize: '12px',
          marginBottom: '1rem'
        }}
      >
        + Nowa sesja
      </button>
    )}

    {/* Zakładki Aktywne / Historia */}
    {(() => {
      const typeLabels = { partial: 'Czastkowa', full: 'Calosciowa', pw: 'PW', delivery_check: 'Kontrola dostawy' };
      const typeColors = { partial: 'var(--info)', full: 'var(--danger)', pw: 'var(--info)', delivery_check: 'var(--warning)' };
      const typeBgColors = { partial: 'var(--info-light)', full: 'var(--danger-light)', pw: 'var(--info-light)', delivery_check: 'var(--warning-light)' };

      const activeSessions = sessions.filter(s => s.status === 'in_progress' || s.status === 'paused');
      const historySessions = sessions.filter(s => s.status === 'converted' || s.status === 'completed');

      const [sessionsTab, setSessionsTab] = sessionsTabState;
      const currentList = sessionsTab === 'active' ? activeSessions : historySessions;

      const PAGE_SIZE = 6;
      const [page, setPage] = sessionsPageState;
      const totalPages = Math.ceil(currentList.length / PAGE_SIZE);
      const paginatedList = currentList.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

      return (
        <>
          {/* Tab switcher */}
          <div style={{ display: 'flex', gap: '4px', marginBottom: '0.75rem' }}>
            {[
              { key: 'active', label: `Aktywne (${activeSessions.length})`, color: 'var(--success)' },
              { key: 'history', label: `Historia (${historySessions.length})`, color: 'var(--purple)' },
            ].map(tab => (
              <button
                key={tab.key}
                onClick={() => { setSessionsTab(tab.key); setPage(1); }}
                style={{
                  flex: 1, padding: '6px 12px', fontSize: '12px', fontWeight: '600',
                  cursor: 'pointer',
                  border: sessionsTab === tab.key ? `2px solid ${tab.color}` : '1px solid var(--border)',
                  backgroundColor: sessionsTab === tab.key ? tab.color : 'var(--card-bg)',
                  color: sessionsTab === tab.key ? '#fff' : 'var(--text-secondary)'
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Lista */}
          {paginatedList.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)', fontSize: '13px' }}>
              {sessionsTab === 'active' ? 'Brak aktywnych sesji. Utworz nowa sesje.' : 'Brak historycznych sesji.'}
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {paginatedList.map((session, idx) => (
                <div
                  key={session.id}
                  style={{
                    backgroundColor: 'var(--card-bg)',
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    borderLeft: `4px solid ${
                      session.status === 'in_progress' ? 'var(--success)' :
                      session.status === 'paused' ? 'var(--warning)' :
                      session.status === 'converted' ? 'var(--purple)' : 'var(--text-muted)'
                    }`
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                      {/* LP */}
                      <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--text-muted)', minWidth: '20px', textAlign: 'center', paddingTop: '2px' }}>
                        {(page - 1) * PAGE_SIZE + idx + 1}
                      </div>
                      <div>
                        <div style={{ fontWeight: '600', fontSize: '13px' }}>
                          {session.name || `Sesja #${session.id}`}
                        </div>
                        <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '3px' }}>
                          {new Date(session.created_at).toLocaleString('pl-PL')}
                        </div>
                        <div style={{ fontSize: '11px', marginTop: '4px', display: 'flex', gap: '4px', flexWrap: 'wrap', alignItems: 'center' }}>
                          <span style={{
                            padding: '1px 6px', borderRadius: '4px', fontSize: '10px', fontWeight: '600',
                            backgroundColor: typeBgColors[session.inventory_type] || 'var(--info-light)',
                            color: typeColors[session.inventory_type] || 'var(--info)'
                          }}>
                            {typeLabels[session.inventory_type] || session.inventory_type}
                          </span>
                          <span style={{
                            padding: '1px 6px', borderRadius: '10px', fontSize: '10px',
                            backgroundColor:
                              session.status === 'in_progress' ? 'var(--success-light)' :
                              session.status === 'paused' ? 'var(--warning-light)' :
                              session.status === 'converted' ? 'var(--purple-light)' : 'var(--border)',
                            color:
                              session.status === 'in_progress' ? 'var(--success)' :
                              session.status === 'paused' ? 'var(--warning)' :
                              session.status === 'converted' ? 'var(--purple)' : 'var(--text-muted)'
                          }}>
                            {session.status === 'in_progress' ? 'W trakcie' :
                             session.status === 'paused' ? 'Wstrzymana' :
                             session.status === 'converted' ? 'Przekonwertowana' :
                             session.status === 'completed' ? 'Zakonczona' : session.status}
                          </span>
                          <span style={{ color: 'var(--text-muted)', fontSize: '10px' }}>
                            {session.items_count || 0} poz.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '0.4rem' }}>
                      {session.status !== 'converted' && session.status !== 'completed' && (
                        <>
                          <button
                            onClick={() => handleSelectSession(session)}
                            style={{ padding: '4px 10px', border: '1px solid var(--info)', color: 'var(--info)', fontSize: '11px' }}
                          >
                            Kontynuuj
                          </button>
                          <button
                            onClick={() => handleDeleteSession(session.id)}
                            style={{ padding: '4px 10px', border: '1px solid var(--danger)', color: 'var(--danger)', fontSize: '11px' }}
                          >
                            X
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Paginacja */}
          {totalPages > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '4px', marginTop: '0.75rem' }}>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                <button
                  key={p}
                  onClick={() => setPage(p)}
                  style={{
                    padding: '4px 10px', fontSize: '12px', cursor: 'pointer',
                    border: p === page ? '2px solid var(--primary)' : '1px solid var(--border)',
                    backgroundColor: p === page ? 'var(--primary)' : 'var(--card-bg)',
                    color: p === page ? '#fff' : 'var(--text-secondary)',
                    fontWeight: p === page ? '700' : '400'
                  }}
                >
                  {p}
                </button>
              ))}
            </div>
          )}
        </>
      );
    })()}
  </div>
  );
};

export default CollectorSessions;
